import { z } from "zod"

export function optionalTupleSchema<Output, Input>(schema: z.Schema<Output, z.ZodTypeDef, Input>) {
  return z.tuple([schema]).or(z.tuple([]))
}
